'use strict';
import {
  DateFormatter,
  DateTimeFormatter
} from '../../../common/DateFormatter';
import {
  DecimalFormatter,
  NumberFormatter,
  DecimalAllDigitsFormatter
} from '../../../common/NumberFormatter';
import  SmartSelect from '../../../common/SmartSelect';

import CustomDateComponent from '../../../common/CustomDateComponent';
import { Datepicker } from '../../../common/Datepicker';
import ReactDatePicker from 'react-datepicker';
import flatpickr from 'flatpickr';
import $ from 'jquery';
import CustomDate from '../../../common/CustomDate';
import {NumericCellEditor} from '../../../common/NumericCellEditor';
import {DecimalCellEditor} from '../../../common/DecimalCellEditor';
import CheckboxRenderer from '../../../common/CheckboxRenderer';
//import { TextCellEditor } from 'ag-grid-enterprise/dist/ag-grid-enterprise';
import {TextCellEditor} from '../../../common/TextCellEditor';
import "ag-grid-enterprise";
import * as ag from "ag-grid-community";


const ReferenceDataGridOptions = () => {
  return {
    autoGroupColumnDef: {
      headerName: 'GROUP',
      pinned: 'left',
      width: 320,
      tooltipValueGetter: function (params) {
        var count = params.node.allChildrenCount;
        if (count != null) {
          return params.value + ' (' + count + ')';
        }
        return params.value;
      }
    },
    frameworkComponents: {
      numberFormatter: NumberFormatter,
      decimalFormatter: DecimalFormatter,
      dateFormatter: DateFormatter,
      dateTimeFormatter: DateTimeFormatter,
      SmartSelect: SmartSelect,
      datePicker: CustomDate,
      numericCellEditor: NumericCellEditor,
      decimalCellEditor: DecimalCellEditor,
      booleanCellEditor: CheckboxRenderer,
      agTextCellEditor: TextCellEditor,
      DecimalAllDigitsFormatter: DecimalAllDigitsFormatter
    },
    components: {
      actionCellRenderer:actionCellRenderer,
    },
    editType:'fullRow',
    pagination: true,
  paginationPageSize: 20,
 suppressClickEdit:true,
    rowSelection: 'single',
    autoSizeColumns: true,
    floatingFilter: true,
    enableRangeSelection: true,
    multiSortKey: 'ctrl',
    rowGroupPanelShow: 'always',
    rememberGroupStateWhenNewData: true,
    statusBar: {
      statusPanels: [
        {
          statusPanel: 'agTotalAndFilteredRowCountComponent',
          align: 'left'
        },
        {
          statusPanel: 'agAggregationComponent',
          statusPanelParams: {
            aggFuncs: ['avg', 'count', 'min', 'max', 'sum']
          }
        }
      ]
    },
    sideBar: {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel'
        }
      ],
      showToolPanel: false
    },
    defaultColDef: {
      enableRowGroup: true,
      enablePivot: true,
      enableValue: true,
      sortable: true,
      filter: true,
      resizable: true
    },
    excelStyles: [],
    onRowEditingStarted: (params) => {
      params.api.refreshCells({
        columns: ['action'],
        rowNodes: [params.node],
        force: true,
      });
    },
    onRowEditingStopped: (params) => {
      params.api.stopEditing(true);
      params.api.refreshCells({
        columns: ['action'],
        rowNodes: [params.node],
        force: true,
      });
    },
  
  };
};
const actionCellRenderer=(params) =>{
  let eGui = document.createElement("div");

  let editingCells = params.api.getEditingCells();
  // checks if the rowIndex matches in at least one of the editing cells
  let isCurrentRowEditing = editingCells.some((cell) => {
    return cell.rowIndex === params.node.rowIndex;
  });

  if (isCurrentRowEditing) {
    eGui.innerHTML = `
<button  class="action-button update cellbtnstl"  data-action="update" > update  </button>
<button  class="action-button cancel cellbtnstl"  data-action="cancel" > cancel </button>
`;
  } else {
    eGui.innerHTML = `
<button class="action-button edit cellbtnstl celleditbtnstl"  data-action="edit" "> edit  </button>

`;
  }
{/* <button class="action-button delete" data-action="delete" > delete </button> */}
  return eGui;
}
const getDatePicker = () => {
  function Datepicker() {}

  Datepicker.prototype.init = function (params) {
    this.eInput = document.createElement('input');
    this.eInput.value = params.value;
     $(this.eInput).datepicker({ dateFormat: "dd/mm/yy" });
  };
  Datepicker.prototype.getGui = function () {
    return this.eInput;
  };
  Datepicker.prototype.afterGuiAttached = function () {
    this.eInput.focus();
    this.eInput.select();
  };
  Datepicker.prototype.getValue = function () {
    return this.eInput.value;
  };
  Datepicker.prototype.destroy = function () {};
  Datepicker.prototype.isPopup = function () {
    return false;
  };

  console.log(Datepicker);
  return Datepicker;
};

const getCustomDateComponent = () => {
  function CustomDateComponent() {}

  CustomDateComponent.prototype.init = function (params) {
    var template =
      '<input type="text" data-input style="width: 100%;" />' +
      '<a class="input-button" title="clear" data-clear>' +
      '<i class="fa fa-times"></i>' +
      '</a>';

    this.params = params;

    this.eGui = document.createElement('div');

    var eGui = this.eGui;

    eGui.setAttribute('role', 'presentation');
    eGui.classList.add('ag-input-wrapper');
    eGui.classList.add('custom-date-filter');
    eGui.innerHTML = template;

    this.eInput = eGui.querySelector('input');

    this.picker = flatpickr(this.eGui, {
      onChange: this.onDateChanged.bind(this),
      dateFormat: 'd/m/Y',
      wrap: true
    });

    this.picker.calendarContainer.classList.add('ag-custom-component-popup');

    this.date = null;
  };
  

  CustomDateComponent.prototype.getGui = function () {
    return this.eGui;
  };

  CustomDateComponent.prototype.onDateChanged = function (selectedDates) {
    this.date = selectedDates[0] || null;
    this.params.onDateChanged();
  };

  CustomDateComponent.prototype.getDate = function () {
    return this.date;
  };

  CustomDateComponent.prototype.setDate = function (date) {
    this.picker.setDate(date);
    this.date = date;
  };

  CustomDateComponent.prototype.setInputPlaceholder = function (placeholder) {
    this.eInput.setAttribute('placeholder', placeholder);
  };

  var comp = new CustomDateComponent();
  console.log(comp);
  //  return comp;
  return CustomDateComponent;
};

export default ReferenceDataGridOptions;
